/* eslint-disable @next/next/no-img-element */
import { Control } from '@yleisradio/areena-types';
import classNames from 'classnames';
import { isNavigator } from 'components/Controls/Control/typeGuards';
import { Link } from 'components/Link';
import React, { FunctionComponent } from 'react';
import { menuImageUrl } from 'utils/cloudinary';
import styles from './MenuItem.module.scss';

type Props = {
  item: Control;
  toggleSubMenu(): void;
};

const icon = (control: Control) => (control.icon ? control.icon.id : null);

export const MenuItem: FunctionComponent<Props> = ({ item, toggleSubMenu }) => {
  const itemImage = item && item.image ? item.image.id : '';
  const classes = classNames(
    styles.menuImage,
    ['lasten-areena', 'barnens-arena'].includes(itemImage) && styles.lastenImg
  );

  return isNavigator(item) ? (
    <li key={item.title} className={styles.menuItem}>
      <Link
        className={styles.menuLink}
        pointer={item.destination}
        data-icon={icon(item)}
        onClick={toggleSubMenu}
      >
        {item.image ? (
          <img
            className={classes}
            aria-label={item.title}
            alt={item.title}
            src={menuImageUrl(item.image)}
          />
        ) : (
          item.title
        )}
      </Link>
    </li>
  ) : null;
};
